module.exports = function() {
  return new Worker(__webpack_public_path__ + "bc7194780f11826d6758.worker.js");
};